import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'P',
}

const component: componentProps = {
	name: 'P',
	shortName: 'P',
	fileName: 'p',
	category: 'typography',
	description: ['A p element with control for typographic attributes.'],
	features: ['Drop-in replacement for the native <p> element.', 'Automatically inherits design tokens.', 'Allows control of size, weight, alignment, and tracking.'],
	parts: [],
	usage: `<P>This is a paragraph.</P>`,
	styling: ``,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const TextRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<P>The tracking's default value depends on the size prop and is controlled through CSS variables: check out the styling section.</P>
			<Usage usage={usage} shortName={shortName} />
			<P>This is a paragraph.</P>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default TextRoute
